import { Skeleton } from '@/components/skeleton/skeleton'
import { Table, TableBody, TableCell, TableRow } from '@/components/table/table'

export const TableLoading = () => {
  return (
    <div className="rounded-md border">
      <Table className="text-sm">
        <TableBody>
          <Row />
          <Row />
          <Row />
          <Row />
          <Row />
          <Row />
          <Row />
          <Row />
          <Row />
          <Row />
        </TableBody>
      </Table>
    </div>
  )
}

const Row = () => {
  return (
    <TableRow className="h-[53px] [&>td]:py-2">
      <TableCell>
        <Skeleton className="h-5 w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-5 w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-5 w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-5 w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-5 w-full" />
      </TableCell>
    </TableRow>
  )
}
